/* eslint-disable @next/next/no-img-element */
/* eslint-disable react/jsx-no-useless-fragment */
/* eslint-disable no-nested-ternary */
/* eslint-disable react/button-has-type */
/* eslint-disable multiline-ternary */
import React from 'react'
import Image from 'next/image'
import assetLoader from '@utils/internalImageLoader'
import styles from './quick-link2.module.scss'

const QuickLinkButton = ({ isToggle, handleSeeMoreClick, isSticky }) => {
  const expandClass = isToggle ? styles.hidden : ''

  const seeMoreIcon = isSticky ? (
    isToggle ? (
      <Image
        src={`${assetLoader()}/images/quick-links-icon/down.svg`}
        alt="down quickLinks icon"
        loading="lazy"
        decoding="async"
        width={10}
        height={8}
      />
    ) : (
      <Image
        src={`${assetLoader()}/images/quick-links-icon/up.svg`}
        alt="up quickLinks icon"
        loading="lazy"
        decoding="async"
        width={10}
        height={8}
      />
    )
  ) : isToggle ? (
    <div className={styles.seeMoreLessContainer}>
      <p className={styles.seeMoreLessText}>See less</p>
      <Image
        src={`${assetLoader()}/images/quick-links-icon/seeLess.svg`}
        alt="see less btn"
        loading="lazy"
        decoding="async"
        width={28}
        height={28}
        className={styles.invertImage}
      />
    </div>
  ) : (
    <div className={styles.seeMoreLessContainer}>
      <p className={styles.seeMoreLessText}>See more</p>
      <Image
        src={`${assetLoader()}/images/quick-links-icon/seeMore.svg`}
        alt="see more btn"
        loading="lazy"
        decoding="async"
        width={28}
        height={28}
      />
    </div>
  )

  return (
    <button
      className={`${styles.expand} ${expandClass}`}
      onClick={() => {
        typeof expandClass === 'undefined'
          ? handleSeeMoreClick('showLess', isSticky)
          : handleSeeMoreClick('showMore', isSticky)
      }}>
      {isSticky && <span>View More</span>}
      {seeMoreIcon}
    </button>
  )
}

export default QuickLinkButton
